import React, {Component} from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import store from 'store'

// component
import Index from './pages/index/index'
import Home from './pages/home/home'
import Login from './pages/login/login'
import MenuLayout from './pages/menuLayout/menuLayout'
import TenantSelect from './pages/tenantSelect/tenantSelect'

import './App.styl';
import { handleCheckToken, checkIsLaunchpad } from "@/utils/util";
import { getParam } from 'ruigu-utils'

class App extends Component{
  constructor(props) {
    super(props)
    if(store.get('token') && store.get('token') !== '' && !getParam('returnURL')) {
      handleCheckToken(store.get('token'));
    }
    // 修改window信息，便于内嵌页面查询父级环境
    window.parentEnvInfo = {
      isLaunchpad: checkIsLaunchpad(),
    }
  }

  render() {
    return (
      <Router>
        <Route path='/' exact component={Index} />
        <Route path='/home' exact component={Home} />
        <Route path='/login' exact component={Login} />
        <Route path='/menuLayout' exact component={MenuLayout} />
        <Route path='/tenantSelect' exact component={TenantSelect} />
      </Router>
    )
  }
}

export default App;
